var pfdialog = {
    okButtonText: "OK",
    cancelButtonText: "Cancel",
    //Title:"",
    //Body:""
    failure: function (options) {        
        this.alert(options);
        $("#popup_container").addClass("failure");
    },
    confirm: function (options) {
        $.alerts.setOptions(options);
        jConfirm(options.Body, options.Title, function (e) {
            if (e == true) {
                if (options.okCallback)
                    options.okCallback(options.context);
            }
            if (e == false) {
                if (options.cancelCallback)
                    options.cancelCallback(options.context);
            }
        });
        $("#popup_container").addClass("confirm");
    },
    error: function (options) {
        this.alert(options);
        $("#popup_container").addClass("error");
    },    
    thankyou: function (options) {
        this.alert(options);
        $("#popup_container").addClass("thankYou");
    },
    alert: function (options) {
        if (!options.okButtonText)
            options.okButtonText = this.okButtonText;
        if (!options.cancelButtonText)
            options.cancelButtonText = this.cancelButtonText;
        $.alerts.setOptions(options);        
        jAlert(options.Body, options.Title, function (e) {
            if (e == true) {
                if (options.okCallback)
                    options.okCallback(options.context);
            }
        });
        $("#popup_container").addClass("alert");
    }

};
define("common/pfdialog", function(){});

